import { getArgumentIndex } from '@wix/motion-edm-autogen-transformations-core';
const withRenamedArgument = (fieldValue, argumentNames) => {
    const argIndex = getArgumentIndex(fieldValue);
    if (argIndex !== null) {
        if (argumentNames?.[argIndex]) {
            return fieldValue.replace(`$[${argIndex}]`, argumentNames[argIndex]);
        }
        return undefined;
    }
    return fieldValue;
};
export { withRenamedArgument };
//# sourceMappingURL=withRenamedArgument.js.map